<template>
    <div>
        <app-data-table
            :fields="fields"
            :items="tableData"
            :current-page="data.current_page"
            :last-page="data.last_page"
            :from="data.from"
            :to="data.to"
            @sort="onSort"
            :total="data.total"
            :per-page="data.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="actions" slot-scope="{ item }">
                <b-button
                    v-if="
                        item.annotation_type.slug == 'transitoria' &&
                            !item.completed &&
                            !isAdminClient
                    "
                    size="sm"
                    variant="primary"
                    @click="startFinalize(item)"
                >
                    <i class="fa fa-check" aria-hidden="true"></i>
                </b-button>
                <i
                    v-if="item.completed !== null"
                    class="fa fa-check"
                    aria-hidden="true"
                ></i>
            </template>

            <template slot="notify_admin" slot-scope="{ item }">
                <div v-if="item.notify_admin">
                    <h5>
                        <i class="fa fa-envelope-o" aria-hidden="true"></i>
                    </h5>
                </div>
                <div v-else></div>
            </template>

            <template slot="created_at" slot-scope="{ item }">{{
                item.created_at | datetime
            }}</template>

            <template slot="photos" slot-scope="data">
                <b-button
                    size="sm"
                    v-if="!data.item._showDetails"
                    :disabled="!data.item.notebook_photos.length"
                    @click.stop="data.toggleDetails"
                    variant="primary"
                >
                    Fotos
                    <b-badge>
                        {{ data.item.notebook_photos.length }}
                    </b-badge>
                </b-button>
                <b-button
                    size="sm"
                    v-else
                    variant="danger"
                    @click.stop="data.toggleDetails"
                >
                    Cerrar
                    <b-badge>
                        {{ data.item.notebook_photos.length }}
                    </b-badge>
                </b-button>
            </template>

            <template slot="content" slot-scope="{ item }">
                <div id="content" v-html="item.content"></div>
            </template>

            <template slot="row-details" slot-scope="data">
                <div class="d-flex justify-content-center">
                    <div class="w-50">
                        <b-carousel
                            id="carousel1"
                            style="text-shadow: 1px 1px 2px #333;"
                            controls
                            indicators
                            background="#ababab"
                            :interval="4000"
                            img-width="350px"
                            img-height="200px"
                        >
                            <b-carousel-slide
                                v-for="photo in data.item.notebook_photos"
                                img-height="200"
                                :key="photo.id"
                                :img-src="photo.photo_url"
                            ></b-carousel-slide>
                        </b-carousel>
                    </div>
                </div>
            </template>
        </app-data-table>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Object,
        },
    },
    data() {
        return {
            fields: [
                {
                    key: 'notify_admin',
                    label: '',
                },
                {
                    key: 'created_at',
                    label: 'Fecha',
                    orderBy: 'notebook.created_at',
                },
                {
                    key: 'user.name',
                    label: 'Autor',
                    orderBy: 'users.name',
                },
                {
                    key: 'assignee.name',
                    label: 'Usuario asociado',
                    orderBy: 'assignees.name',
                },
                {
                    key: 'annotation_type.short_name',
                    label: 'Tipo',
                    orderBy: 'annotation_types.name',
                },
                {
                    key: 'content',
                    label: 'Anotación',
                },
                {
                    key: 'photos',
                    label: 'Fotos',
                    sortable: false,
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                },
            ],
            isAdminClient: false,
            slide: 1,
        }
    },
    computed: {
        tableData() {
            if (!this.data || !this.data.data) return []

            const data = this.data.data

            const dictionary = {
                ['cliente-admin']: 'alert alert-info',
                ['supervisor']: 'alert alert-danger',
                ['administrativo']: 'alert alert-warning',
                ['vigilante']: '',
            }
            const theData = data.map(item => {
                if (!item.user.profile) {
                }
                const classes = dictionary[item.user.profile.slug]
                return { ...item, classes }
            })

            return theData
        },
    },
    methods: {
        onChangePage(page) {
            this.$emit('change-page', page)
        },
        onSort(ctx) {
            this.$emit('sort', ctx)
        },
        startFinalize(data) {
            this.$emit('start-finalize', data)
        },
    },
    created() {
        this.isAdminClient =
            this.user.profile.slug === 'cliente-admin' ? true : false
    },
}
</script>
<style>
#content {
    font-size: 17px;
}
</style>
